var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
          fill: "white",
          "fill-opacity": "0.2"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "4",
          y: "4",
          width: "40",
          height: "40",
          rx: "20",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          opacity: "0.4",
          d:
            "M10.9646 24.2043L18.5328 19.6746C21.7249 17.7633 25.6929 17.7006 28.9436 19.5109L38.3886 24.768L43.6557 27.6996C43.9688 26.0247 44.0739 24.275 43.9405 22.4829C43.1728 12.1688 34.4611 4.05688 24.121 4.00031C12.7122 3.93768 3.56615 13.3952 4.0187 24.8044C4.42883 35.1448 12.8577 43.582 23.1977 43.982C28.6547 44.1942 33.6267 42.2222 37.3441 38.8866L10.9646 24.2043Z",
          fill: "url(#paint0_linear_473_11757)"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          opacity: "0.4",
          d:
            "M30.6968 35.1849L22.9912 30.8956C19.7405 29.0874 17.702 25.681 17.6434 21.9614L17.4737 11.1523L17.3787 5.12542C15.7705 5.69114 14.2048 6.47505 12.7198 7.48727C4.17177 13.308 1.50089 24.9092 6.62244 33.8939C12.2733 43.806 25.0358 46.9982 34.6889 40.9007C43.437 35.3749 46.5301 23.8586 41.7076 14.7021C39.162 9.87135 34.9677 6.54981 30.222 4.99814L30.6968 35.1849Z",
          fill: "url(#paint1_linear_473_11757)"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          opacity: "0.4",
          d:
            "M30.3375 12.6052L30.4769 21.4242C30.5355 25.1438 28.606 28.6128 25.4139 30.5221L16.1385 36.0741L10.9665 39.1694C12.2615 40.2786 13.7222 41.2444 15.3405 42.0242C24.6563 46.5156 36.0368 43.0263 41.2574 34.0982C47.0153 24.2487 43.3989 11.599 33.2932 6.28737C24.131 1.47478 12.611 4.55589 7.09351 13.3103C4.1822 17.9289 3.40235 23.2224 4.43272 28.1097L30.3375 12.6052Z",
          fill: "url(#paint2_linear_473_11757)"
        }
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_473_11757",
                x1: "6.52353",
                y1: "14.273",
                x2: "40.5787",
                y2: "33.2273",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#07A893" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.26", "stop-color": "#07A394" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.52", "stop-color": "#0A9797" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "0.8", "stop-color": "#0F829D" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#146EA3" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint1_linear_473_11757",
                x1: "21.8453",
                y1: "-13.2193",
                x2: "56.7602",
                y2: "6.21341",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#07A893" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.26", "stop-color": "#07A394" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.52", "stop-color": "#0A9797" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "0.8", "stop-color": "#0F829D" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#146EA3" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint2_linear_473_11757",
                x1: "3.92131",
                y1: "12.8226",
                x2: "41.4701",
                y2: "33.7213",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#07A893" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.26", "stop-color": "#07A394" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.52", "stop-color": "#0A9797" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "0.8", "stop-color": "#0F829D" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#146EA3" } })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }